import {
  GET_LOTTERY_DRAW_ACTIVE_REQUEST,
  GET_LOTTERY_DRAW_ACTIVE_SUCCESS,
  GET_LOTTERY_DRAW_ACTIVE_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LOTTERY_DRAW_ACTIVE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_LOTTERY_DRAW_ACTIVE_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case GET_LOTTERY_DRAW_ACTIVE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
